<template>
  <AnexosRecomendacion
    v-model="bModal"
    :oDataAnexos="oData"
    :bCargandoInformacion="bCargando"
  />
</template>

<script>
import axiosServices from "@/services/axiosServices.js";
import oJsonAnexos from "@/assets/file/json_anexos.js";
import AnexosRecomendacion from "@/components/Seif/riesgos/AnexosRecomendacion.vue";

export default {
  name: "ModalImagenes",
  props: {
    bMostrarModal: {
      type: Boolean,
      default: false,
    },
    oDataParent: {
      type: Object,
      default: () => {},
    },

    sIdCampo: {
      // Se recibe el nombre del campo de la llave principapara extracto el id valor
      type: String,
      default: "",
    },
    sNombreTabla: {
      type: String,
      default: "",
    },
  },
  //
  components: {
    AnexosRecomendacion,
  },
  data() {
    return {
      sIdLlaveForanea: "", // Indica elid d e filtro para traer la info
      oData: {
        imagenes: [],
        archivos: [],
      }, // Informacion de las firmas
      oCampos: {},
      bModal: this.bMostrarModal,
      bCargando: false,
    };
  },
  async mounted() {
    this.onGetItems();
  },
  methods: {
    onObtenerNombreArchivo(sUrl) {
      return sUrl.substring(sUrl.lastIndexOf("/") + 1);
    },
    async onGetItems() {
      this.bCargando = true;
      if (oJsonAnexos.hasOwnProperty(this.sNombreTabla.split("$")[0])) {
        this.oCampos = oJsonAnexos[this.sNombreTabla.split("$")[0]].oFotos;
        this.sIdLlaveForanea = this.oDataParent[this.sIdCampo];
        var sParams =`sTabla=${oJsonAnexos[this.sNombreTabla.split("$")[0]].oFotos.sTablaAnexos}&nValor=${this.sIdLlaveForanea}&oCampos=${JSON.stringify(this.oCampos)}`;

        const { aData } = await axiosServices.getConfiguration("/pGrids_Anexos",true,sParams);
        this.bCargando = false;
        aData.forEach((oItem) => {
          if (oItem[this.oCampos.sTipoAnexo] === "1") {
            this.oData.imagenes.push({urlAnexo: oItem[this.oCampos.sAnexo]});
          } else {
            this.oData.archivos.push({urlAnexo: oItem[this.oCampos.sAnexo], nombre: this.onObtenerNombreArchivo(oItem[this.oCampos.sAnexo])});
          }
        })
      } else {
        this.bCargando = false;
      }
    },
  },
  watch: {
    bModal() {
      if (!this.bModal) this.$emit("onCerrarDialog", this.bModal);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>